import type { ReactNode } from 'react'

import type { ThemeColors } from '@segment/matcha/foundations/Theme'

import { BusinessIcon, CheckIcon, DollarIcon, ToolIcon } from '@segment/matcha/components/Icons/Brandbook'

interface Card {
  key: string
  icon: ReactNode
  title: string
  description: string
}

export const cards = (color: ThemeColors): Card[] => [
  {
    key: `Segment-credits`,
    icon: <DollarIcon color={color} />,
    title: `Segment credits`,
    description: `Eligible startups get full access to our team plan (up to $25,000 value) free for up to two years.`,
  },
  {
    key: `$1M-in-free-software`,
    icon: <ToolIcon color={color} />,
    title: `$1M in free software`,
    description: `We’ve partnered with marketing and analytics companies like Amplitude, AWS, and Intercom to offer sweet deals on the tools startups need most.`,
  },
  {
    key: `Startup-resources`,
    icon: <BusinessIcon color={color} />,
    title: `Startup resources`,
    description: `We’ve designed resources to help you level up your data and analytics like Analytics Office Hours and Analytics Academy.`,
  },
  {
    key: `Eligibility-requirements`,
    icon: <CheckIcon color={color} />,
    title: `Eligibility requirements`,
    description: `Incorporated less than 2 years ago + raised no more than $5MM in total funding.`,
  },
]
